module.exports = __webpack_public_path__ + "static/media/bg.8713ec2c.png";